import React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'gatsby'
import { forSmallScreenUp } from '../utils/style'

const Wrapper = styled.nav`
  margin: var(--spacing-0);
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  li:last-child {
    text-align: right;
  }
  ${forSmallScreenUp(css`
    ul {
      display: flex;
      justify-content: space-between;
    }
    li:first-child {
      width: 45%;
    }
    li:last-child {
      text-align: right;
      width: 45%;
    }
  `)}
`

export const PostNav = ({ previousPost, nextPost }) => {
  return (
    <Wrapper>
      <ul>
        <li>
          {previousPost && (
            <Link to={previousPost.slug} rel="prev">
              ← {previousPost.title}
            </Link>
          )}
        </li>
        <li>
          {nextPost && (
            <Link to={nextPost.slug} rel="next">
              {nextPost.title} →
            </Link>
          )}
        </li>
      </ul>
    </Wrapper>
  )
}
